import { deleteWatchlist } from 'actions/watchlist-actions'
import { Trans } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useModalDispatch, useModalState } from 'hooks/use-modal'
import { WatchlistsModalsState, WatchlistsModalId } from 'constants/modals'
import ModalWTN from 'components/generic/ModalWTN'
import i18n from 'constants/strings'
import { AppState } from 'redux/reducers'

const DeleteWatchListModal = () => {
  const dispatch = useDispatch()
  const { watchlistId } = useModalState<WatchlistsModalsState, WatchlistsModalId.DELETE_WATCHLIST>(
    WatchlistsModalId.DELETE_WATCHLIST
  )
  const { modalDispatch, modalActions } = useModalDispatch<
    WatchlistsModalsState,
    WatchlistsModalId.DELETE_WATCHLIST
  >(WatchlistsModalId.DELETE_WATCHLIST)
  const handleCloseModal = () => modalDispatch(modalActions.closeModal())
  const handleConfirm = () => {
    dispatch(deleteWatchlist(watchlistId))
    handleCloseModal()
  }

  const watchlistName = useSelector(
    (state: AppState) => state.watchlists.watchlists[watchlistId]?.name ?? ''
  )

  return (
    <ModalWTN
      modalId={WatchlistsModalId.DELETE_WATCHLIST}
      widgetElId='watchlists'
      textHeader={i18n.t('strWatchlists.deleteModal.title')}
      btnAlignment='right'
      btnPrimary={{
        text: i18n.t('strCommonUI.button.yesDelete'),
        onClick: handleConfirm,
      }}
      btnSecondary={{
        text: i18n.t('strCommonUI.button.noCancel'),
        onClick: handleCloseModal,
      }}
    >
      <Trans>
        Are you sure you want to delete permanently <b>‘{{ name: watchlistName }}’</b> watchlist
        together with players in that watchlist?
      </Trans>
    </ModalWTN>
  )
}

export default DeleteWatchListModal
